export default __webpack_public_path__ + "static/media/block4.1f6ccea2.webp";